<style lang="less" scoped>
.add-box {
	width: 38px;
	height: 38px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #ffffff;
	border: 1px dashed #c6c8d1;
	border-radius: 5px;
	i {
		font-size: 30px;
		color: #c6c8d1;
	}
}
.drag-box {
}
/deep/ .el-upload__tip {
	color: #f04961;
}
.hide-upload {
	/deep/ .el-upload {
		display: none;
	}
	.el-upload__tip {
		display: none;
	}
	/deep/ .el-upload-list__item-delete {
		display: none !important;
	}
	/deep/ .el-upload-list__item-status-label{
		display: none;
	}
	/deep/ .el-upload-list.is-disabled .el-upload-list__item:hover .el-upload-list__item-status-label{
		display: none;
	}
}
.hide-add-box {
	/deep/ .el-upload {
		display: none;
	}
	.el-upload__tip {
		display: none;
	}
}
.btn-upload {
	/deep/ .el-upload {
		display: block;
	}
}
/deep/ .el-upload--picture-card {
	background-color: inherit;
	border: none;
	height: 40px;
	width: 40px;
	line-height: 40px;
}
.avatar-upload {
	/deep/ .el-upload-list--picture-card {
		.el-upload-list__item {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			overflow: hidden;
		}
		.el-upload-list__item-status-label {
			display: none;
		}
	}
}
.upload-component {
	/deep/ .el-upload-list--text{
		.el-upload-list__item{
			display: flex;
			align-items: center;

		}
		.el-upload-list__item-status-label{
			top: 2px;
		}
		.el-upload-list__item__operate{ 
			padding-right: 6px;
			width: 60px;
			.remove-btn{
				font-size: 12px;
				color: #f89898;
				cursor: pointer;
				display: inline-block;
				margin-left: 2px;
			}
			.remove-btn:hover{
				color: rgb(245, 108, 108);
			}
			.preview-btn{
				font-size: 12px; 
				color: #79bbff; 
				cursor: pointer;
				display: inline-block;
				margin-right: 6px;
			}
			.download-btn{
				font-size: 12px; 
				color: #95d475; 
				cursor: pointer;
				display: inline-block;
			}
			.preview-btn:hover{
				color: #409eff; 
			}
			.download-btn:hover{
				color: #67C23A; 
			}
		}
	}
	/deep/ .el-upload-list--picture-card {
		.el-upload-list__item {
			width: 40px;
			height: 40px;
		}
		.el-upload-list__item__operate{ display: flex; align-items: center; justify-content: center; height: 38px; position: relative; z-index: 1;
			.el-upload-list__item__operate__img{
				position: absolute;
				left: 0;
				top:0;
				right: 0;
				bottom: 0;
				z-index: 2;
				width: 100%;
				height: 100%;
			}
			.remove-btn{
				font-size: 18px;
				color: #f89898;
				cursor: pointer;
				display: inline-block;
				height: 18px;
				line-height: 18px;
				font-weight: bolder;
				z-index: 3;
			}
			.remove-btn:hover{
				color: rgb(245, 108, 108);
			}
			.preview-btn{
				font-size: 18px; 
				color: #79bbff; 
				cursor: pointer;
				display: inline-block;
				height: 18px;
				line-height: 18px;
				font-weight: bolder;
				z-index: 3;
			}
			.download-btn{
				font-size: 18px; 
				color: #95d475; 
				cursor: pointer;
				display: inline-block;
				height: 18px;
				line-height: 18px;
				font-weight: bolder;
				z-index: 3;
			}
			.preview-btn:hover{
				color: #409eff; 
			}
			.download-btn:hover{
				color: #67C23A; 
			}
		}
		.el-upload-list__item__operate:hover{
			.el-upload-list__item__operate__img{
				opacity: .2;
			}
		}
	}
	/deep/ .el-upload-list--picture-card .el-upload-list__item-actions{ font-size: 18px;
		span+span{ margin-left: 0; }
	}
}

/deep/ .el-upload-list__item {
	transition: none !important;
}
</style>
<template>
	<el-upload
		:name="uploadParamsName"
		class="upload-component"
		:class="{
			'hide-upload': disabled,
			'hide-add-box': isExceed,
			'avatar-upload': uploadStyle === 'avatar',
			'btn-upload': uploadStyle === 'btn',
		}"
		:drag="uploadStyle === 'drag'"
		:headers="uploadHeader"
		:disabled="disabled"
		:limit="limit"
		:action="actionUrl"
		:accept="accept"
		:multiple="multiple"
		:list-type="listType"
		:file-list="fileDataList.fileList"
		:show-file-list="uploadStyle !== 'btn'"
		:auto-upload="autoUpload"
		:on-success="onSuccess"
		:on-remove="onRemove"
		:on-error="onError"
		:on-exceed="onExceed"
		:before-upload="onBeforeUpload"
		:on-preview="onPreview"
	>
		<div v-if="uploadStyle === 'avatar'" class="avatar-box">
			<el-avatar
				:size="60"
				src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
			></el-avatar>
		</div>
		<div v-if="uploadStyle === 'normal'" class="add-box">
			<i class="el-icon-plus"></i>
		</div>
		<div v-if="uploadStyle === 'btn'" class="add-btn-box">
			<el-button type="primary" :disabled="disabled"><i class="el-icon-upload"></i>
                                       导入</el-button>
		</div>
		<div v-if="uploadStyle === 'drag'" class="drag-box">
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
		</div>
		<template #file="{ file }">
			<div style="flex: 1; position: relative; min-width: 0;">
				<a class="el-upload-list__item-name">
				<i class="el-icon-document"></i>{{ file.name }}</a>
				<label class="el-upload-list__item-status-label">
					<i class="el-icon-upload-success el-icon-circle-check"> </i>
				</label>
			</div>
			<div class="el-upload-list__item__operate" v-if="listType === 'picture-card'">
				<img class="el-upload-list__item__operate__img" :src="file.url" alt="">
				<i class="el-icon-zoom-in preview-btn" @click="onPreview(file)"></i>
				<i class="el-icon-delete remove-btn" v-if="!disabled" @click="handleRemove(file)"></i>
				<i class="el-icon-download download-btn" v-else @click="downFile(file)"></i>
			</div>
			<div class="el-upload-list__item__operate" v-else>
				<span type="primary" class="preview-btn" @click="onPreview(file)">预览</span>
				<span type="primary" class="remove-btn" v-if="!disabled" @click="handleRemove(file)">移除</span>
				<span type="primary" class="download-btn" v-else @click="downFile(file)">下载</span>
			</div>
		</template>
		<template #tip>
			<div v-if="accept" class="el-upload__tip">
				只能上传 {{ accept }} 文件,单个文件不超过50兆(MB)
			</div>
			<div v-else class="el-upload__tip">可以上传所有类型的文件,单个文件不超过50兆(MB)</div>
		</template>
	</el-upload>
	<ElImageViewer
		v-if="previewObj.visible"
		:hide-on-click-modal="true"
		:url-list="previewObj.urlList"
		:initial-index="previewObj.index"
		@close="
			() => {
				previewObj.visible = false;
			}
		"
	/>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, ref, watch, inject, onMounted } from "vue";
import { flowHooks } from "@/hooks/factoryHooks";
import { ElNotification, ElLoading, ElImageViewer, ElMessageBox } from "element-plus";
import $api from "@/api/main";
import utils from "@/utils/utils";
import router from "@/router";
import { baseURL } from "@/utils/request";
import Bus from "@/bus";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		/**
		 * 是否自动上传
		 */
		autoUpload: {
			type: Boolean,
			default: true,
		},
		/**
		 * 是否需要下载
		 */
		needDownLoad: {
			type: Boolean,
			default: false,
		},
		/**
		 * 是否禁用
		 */
		disabled: {
			type: Boolean,
			default: false,
		},

		/**
		 * 回显文件列表
		 */
		fileLists: {
			type: Array,
			default: () => [],
		},

		/**
		 * 文件个数限制
		 */
		limit: {
			type: Number,
			default: 99,
		},

		/**
		 * 是否可以多选
		 */
		multiple: {
			type: Boolean,
			default: false,
		},

		/**
		 * 上传框类型
		 * 可选值： normal/drag/avatar
		 */
		uploadStyle: {
			type: String,
			default: "normal",
		},

		/**
		 * 文件预览类型
		 * 可选值： local/plugin
		 */
		previewType: {
			type: String,
			default: "plugin",
		},

		/**
		 * 已上传图片显示方式
		 * 可选值： text/picture/picture-card
		 */
		listType: {
			type: String,
			default: "text",
		},

		/**
		 * 接收文件的类型
		 */
		accept: {
			type: String,
			default: "",
		},

		/**
		 * 文件发生变化的回调
		 */
		onChange: {
			/* eslint-disable */
			type: Function as PropType<() => void>,
			default: () => {
				return () => {};
			},
		},
		/**
		 * 文件上传Url
		 */
		actionUrl: {
			type: String,
			default: "",
		},
		/**
		 * 文件上传参数名
		 */
		paramsName: {
			type: String,
			default: "files",
		},
	},
	emits: ["getResult"],
	setup(props, ctx: any) {
		const { previewFn } = flowHooks();
		const previewObj: any = reactive({
			visible: false,
			urlList: [],
			index: 0,
		});
		let uploadParamsName = props.paramsName ? props.paramsName : "files";
		// 上传loading实例
		let loading: any = null;
		let downloadLoading: any = null;
		// 默认上传地址
		const actionUrl = props.actionUrl
			? `${baseURL}${props.actionUrl}`
			: `${baseURL}file/upload/file`;
		// 上传需要携带的header
		let uploadHeader = {
			Authorization: decodeURIComponent(utils.$cookie.getCookie(utils.$tokenStr)),
		};

		// 传输进来的默认文件列表
		const fileDataList: any = reactive({
			fileList: [],
		});
		// 是否显示上传组件
		let isExceed = ref(false);
		isExceed.value = props.disabled;

		// 根据传入的数据回显
		const echoDataFn = () => {
			// 判断传入的数据是否为空，如果不为空则修改成element-plus能识别的字段名称
			if (props.fileLists && props.fileLists.length > 0) {
				if (props.fileLists.length >= props.limit) isExceed.value = true;
				fileDataList.fileList = [];
				previewObj.urlList = [];
				props.fileLists.forEach((item: any) => {
					fileDataList.fileList.push({
						fileId: item.fileId,
						name: item.fileName,
						url: `${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
							utils.$tokenStr
						)}`,
					});
					if (
						item.fileName &&
						(item.fileName.indexOf("png") !== -1 ||
							item.fileName.indexOf("jpg") !== -1 ||
							item.fileName.indexOf("jpeg") !== -1)
					) {
						previewObj.urlList.push(
							`${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
								utils.$tokenStr
							)}`
						);
					}
				});
			} else {
				fileDataList.fileList = [];
			}
		};
		echoDataFn();

		/**
		 * 监听fileLists变化
		 */
		watch(
			() => props.fileLists,
			(val) => {
				echoDataFn();
			}
		);
		watch(
			() => props.disabled,
			(val) => {
				isExceed.value = val;
			}
		);

		// 上传成功的回调函数
		const onSuccess = (res: any, file: any, fileList: any) => {
			console.log(res);
			loading.close();
			if (fileList.length >= props.limit) isExceed.value = true;
			if (props.uploadStyle !== "btn") {
				mixData(fileList);
			}
			if (res.code !== 200) {
				ElNotification({
					title: "错误",
					dangerouslyUseHTMLString: true,
					message: res.msg,
					type: "error",
				});
			}else{
				ctx.emit("uploadSucces", res);
			}
		};
		// 移除文件的回调函数
		const onRemove = (files: any, fileList: any) => {
			if (fileList.length < props.limit) isExceed.value = false;
			mixData(fileList);
		};
		// 移除文件的回调函数
		const handleRemove = (files: any) => {
			fileDataList.fileList.forEach((item: any, index: any) => {
				if (item.fileId === files.fileId) {
				fileDataList.fileList.splice(index, 1);
				}
			});
			if (fileDataList.fileList.length < props.limit) isExceed.value = false;

			mixData(fileDataList.fileList);
		};
		// 上传失败的回调函数
		const onError = (err: any, file: any, fileList: any) => {
			loading.close();
			let error = JSON.parse(err.message);
			if (error.code == 401) {
				ElMessage({
					message: "登录信息过期，请重新登录!",
					showClose: true,
					type: "warning",
				});
				setTimeout(function () {
					utils.$cookie.clearToken();
					router.push({
						path: "/login",
					});
				}, 2000);
			} else {
				ElNotification({
					title: "错误",
					message: `文件上传错误，请稍后再试!`,
					type: "error",
				});
			}
		};
		// 上传文件前的回调函数
		const onBeforeUpload = (file: any) => {
			// 限制20M
			let isFitSize = file.size / 1024 / 1024 < 50;
			if (!isFitSize) {
				ElNotification({
					title: "错误",
					message: `文件上传错误，文件大小不能超过50兆(MB)!`,
					type: "error",
				});
			}
			if (props.accept) {
				let str = props.accept.replaceAll(".", "");
				let arr = str.split(",");
				let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
				if (arr.indexOf(fileName) == -1) {
					ElNotification({
						title: "错误",
						message: `只能上传 ${props.accept}文件!`,
						type: "error",
					});
					isFitSize = false;
				}
			}
			if (isFitSize) {
				loading = ElLoading.service({
					lock: true,
					text: "文件上传中，请稍后!",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.2)",
				});
			}

			return isFitSize;
		};
		// 文件预览的回调函数
		const onPreview = async (file: any) => {
			let fileId = "",
				fileName = "";
			if (file.hasOwnProperty("fileId")) {
				fileId = file.fileId;
				fileName = file.name;
				if (!fileName) {
					let file = await $api.getFileDetail(fileId);
					fileName = file.fileName;
				}
			} else {
				fileId = file.response.data[0].id;
				fileName = file.response.data[0].fileName;
			}
			if (props.needDownLoad) {
				ElMessageBox.confirm(
					"请注意：加密文件只能下载无法预览，请实际情况选择!",
					"请选择",
					{
						distinguishCancelAndClose: true,
						confirmButtonText: "预览",
						cancelButtonText: "下载",
					}
				)
					.then(() => {
						if (
							props.previewType === "plugin" &&
							fileName.indexOf("png") === -1 &&
							fileName.indexOf("jpg") === -1 &&
							fileName.indexOf("jpeg") === -1
						) {
							previewFn(fileId, fileName);
						} else {
							previewObj.index = previewObj.urlList.findIndex((item:any) => {
								return item === file.url;
							});
							previewObj.visible = true;
						}
					})
					.catch((action) => {
						if (action === "cancel") {
							window.open(
								`${baseURL}public/file/${fileId}?token=${utils.$cookie.getCookie(
									utils.$tokenStr
								)}`
							);
						}
					});
			} else {
				if (
					props.previewType === "plugin" &&
					fileName.indexOf("png") === -1 &&
					fileName.indexOf("jpg") === -1 &&
					fileName.indexOf("jpeg") === -1
				) {
					previewFn(fileId, fileName);
				} else {
					previewObj.index = previewObj.urlList.findIndex((item:any) => {
						return item === file.url;
					});
					previewObj.visible = true;
				}
			}
		};

		// 超出文件数量限制的回调函数
		const onExceed = (files: any, fileList: any) => {
			ElNotification({
				title: "警告",
				message: `超出文件最大限制，最多只能上传${props.limit}个文件`,
				type: "warning",
			});
		};

		// 整合返回数据
		const mixData = (dataList: Array<Object>) => {
			let result: Array<Object> = [];
			dataList.forEach((item: any) => {
				if (item.hasOwnProperty("fileId")) {
					result.push({
						fileName: item.name,
						fileId: item.fileId,
					});
				} else {
					result.push({
						fileName: item.name,
						fileId: item.response.data[0].id,
					});
				}
			});
			ctx.emit("getResult", result);
		};
		//下载
		const downFile = (file: any) => {
			downloadLoading = ElLoading.service({
				lock: true,
				text: "文件下载中，请稍后!",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.2)",
			});
			const url = file.url
			let x = new XMLHttpRequest();
			x.open("GET", url, true);
			x.responseType = "blob";
			x.onload = function() {
				let url = window.URL.createObjectURL(x.response);
				let a = document.createElement("a");
				a.href = url;
				a.download = file.name;
				a.click();
			};
			x.send();
			x.onloadend = function() {
				downloadLoading.close();
			};
		};

		onMounted(() => {
			Bus.$on("refreshFlag", (flag: any) => {
				uploadHeader = {
					Authorization: decodeURIComponent(utils.$cookie.getCookie(utils.$tokenStr)),
				};
			});
		});

		return {
			actionUrl,
			uploadHeader,
			onSuccess,
			onRemove,
			onError,
			onBeforeUpload,
			onPreview,
			onExceed,
			handleRemove,
			downFile,
			fileDataList,
			isExceed,
			uploadParamsName,
			previewObj,
		};
	},
	mounted() {},
});
</script>
